import axios from 'axios';
import AuthenticationService from './AuthenticationService';

export const contactService = {
  create,
  getAll,
  updateStatus
};

function create(contact) {
  const url = `${process.env.REACT_APP_API_URL}/api/contacts`;

  return axios.post(url, { contact });
}

function getAll(pageNumber) {
  const requestOptions = {
    method: 'GET',
    headers: Object.assign(
      {},
      {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    )
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  let url = `${process.env.REACT_APP_API_URL}/api/contacts/?page[number]=${
    pageNumber ? pageNumber : 1
  }`;

  return axios.get(url, requestOptions);
}

function updateStatus(contact) {
  const headersOptions = {
    headers: {
      Accept: 'application/json'
    }
  };

  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    headersOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/contacts/${contact.id}`;

  return axios.put(url, { contacts: { ...contact } }, headersOptions);
}
